import React from 'react';
import { useDispatch } from 'react-redux';
import { Menu, Dropdown } from 'antd';
import styled from 'styled-components';
import { theme } from 'styles/theme';
import calendarDateRange from 'assets/calendar-date-range.svg';
import Filter from 'assets/filter.svg';
import { Image, Text, Flex } from 'atoms';
import { setSelectedFilter } from 'store/leaveSlice';

const Dot = styled(Flex)`
	height: 10px;
	width: 10px;
	border-radius: 20px;
`;

export default function DashboardFilter() {
	const dispatch = useDispatch();

	const menu = (
		<Menu>
			<Menu.Item key="0">
				<Flex
					justifyContent="flex-start"
					alignItems="center"
					onClick={() => dispatch(setSelectedFilter('DateRange'))}
				>
					<Image src={calendarDateRange} alt="DateRange" height={15} width={15} />
					<Text ml="10px" fontSize="10px">
						Date Range
					</Text>
				</Flex>
			</Menu.Item>
			<Menu.Divider />
			<Menu.Item key="1">
				<Flex
					justifyContent="flex-start"
					alignItems="center"
					onClick={() => dispatch(setSelectedFilter('Pending'))}
				>
					<Dot bg={theme.colors.YellowOrg} />
					<Text ml="10px" fontSize="10px">
						Pending
					</Text>
				</Flex>
			</Menu.Item>
			<Menu.Divider />
			<Menu.Item key="2">
				<Flex
					justifyContent="flex-start"
					alignItems="center"
					onClick={() => dispatch(setSelectedFilter('Rejected'))}
				>
					<Dot bg={theme.colors.TartOrange} />
					<Text ml="10px" fontSize="10px">
						Rejected
					</Text>
				</Flex>
			</Menu.Item>
			<Menu.Divider />
			{/* <Menu.Item key="7">
				<Flex
					justifyContent="flex-start"
					alignItems="center"
					onClick={() => dispatch(setSelectedFilter('Partially Accepted'))}
				>
					<Dot bg={theme.colors.FuchsiaCrayola} />
					<Text ml="10px" fontSize="10px">
						Partially Accepted
					</Text>
				</Flex>
			</Menu.Item>
			<Menu.Divider /> */}
			<Menu.Item key="3">
				<Flex
					justifyContent="flex-start"
					alignItems="center"
					onClick={() => dispatch(setSelectedFilter('Approved'))}
				>
					<Dot bg={theme.colors.Emerald} />
					<Text ml="10px" fontSize="10px">
						Approved
					</Text>
				</Flex>
			</Menu.Item>
		</Menu>
	);

	return (
		<Dropdown
			trigger={['click']}
			overlay={menu}
			placement="bottomRight"
			overlayStyle={{
				marginTop: '60px',
				marginRight: '30px',
				color: '#0168D0',
			}}
		>
			<Image src={Filter} alt="filter" />
		</Dropdown>
	);
}
